import { HardHat } from 'lucide-react';
import { Badge } from '@proerp/ui';
import { formatDate } from '@/lib/format';
import { useAssemblyTasks } from '@/features/assembly/assemblyApi';
import { TaskCard, TaskRow } from './TaskCard';

/** Noch nicht abgeschlossene Status eines Montage-Einsatzes. */
const ACTIVE_STATUSES = new Set(['PLANNED', 'CONFIRMED']);

/**
 * Meine Montage-Einsätze (ADR 0062): serverseitig auf den mit dem User verknüpften
 * Mitarbeiter gefiltert (`mine=true`). Zeigt die noch offenen Einsätze, nächster
 * Termin zuerst. „Monteur", nicht „Techniker" (CLAUDE.md §12).
 */
export function MyAssemblyWidget() {
  const query = useAssemblyTasks({ mine: true });
  const active = (query.data?.data ?? []).filter((task) => ACTIVE_STATUSES.has(task.status));

  return (
    <TaskCard
      title="Meine Montage-Einsätze"
      icon={HardHat}
      isLoading={query.isLoading}
      isEmpty={active.length === 0}
      emptyText="Dir ist aktuell kein Montage-Einsatz zugewiesen."
    >
      {active.slice(0, 6).map((task) => (
        <TaskRow
          key={task.id}
          to="/montage"
          left={
            <>
              <span className="text-foreground">{task.title}</span>
              {task.projectCode && (
                <span className="ml-2 font-mono text-xs text-muted-foreground">{task.projectCode}</span>
              )}
              {task.location && <span className="ml-2 text-xs text-muted-foreground">{task.location}</span>}
            </>
          }
          right={
            task.plannedStart ? (
              <Badge tone="neutral">{formatDate(task.plannedStart)}</Badge>
            ) : (
              <span className="text-xs text-muted-foreground">ohne Termin</span>
            )
          }
        />
      ))}
    </TaskCard>
  );
}
